import { createInterfaceClass } from 'component-registry';
var Interface = createInterfaceClass('influence-app-entities');
export var IUnsplashImage = new Interface({
  name: 'IUnsplashImage'
});